import { Component, OnInit } from '@angular/core';
import { MiraieService } from '../Services/miraie.service';
import { AnalysisService } from '../Services/analysis.service';
import { OutputService } from '../Services/output.service';

import { Summary } from './summary';
import { FormService } from '../Services/form.service';
import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent implements OnInit {
  logininfo: Logininfo = this.auth.loginID;
  objectKeys = Object.keys;
  years: number[] = [2018, 2017, 2016, 2015, 2014];
  months: number[] = [7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6];
  year: number;
  month;
  span = "now";
  start_span;
  end_span;

  summary_list = {};
  now_summary;
  pay_list = {};
  srcurl: string;

  constructor(
    private miraieService: MiraieService,
    private analysisService: AnalysisService,
    private outputService: OutputService,
    private fs: FormService,
    public auth: AuthService
  ) {
    this.years = this.fs.formSetYear2(2018);
  }

  ngOnInit() {
    this.srcurl = this.miraieService.srcurl;
    this.year = new Date().getFullYear();
    this.month = 'all';
    let now = new Date();

    //検索期間の初期値設定（当月の初日と末日）
    this.start_span = {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      day: new Date(now.getFullYear(), now.getMonth(), 1).getDate()
    }
    this.end_span = {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      day: new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate()
    }
    //売上リストの初期化処理
    this.listInit();

    //本年度のデータ取得
    let start = {
      year: now.getFullYear(),
      month: 7,
      day: new Date(now.getFullYear(), 6, 1).getDate()
    }
    let end = {
      year: now.getFullYear() + 1,
      month: 6,
      day: new Date(now.getFullYear() + 1, 6, 0).getDate()        //6月末日
    }

    this.analysisService.getSalesSummary(start, end).subscribe(result => {
      this.now_summary = this.analysis(result);
    })
    this.analysisService.getSalesSummary(this.start_span, this.end_span).subscribe(result => {
      this.summary_list = this.analysis(result);
    })
  }


  //指定した期間のデータ取得
  changeYear() {
    //本年度のデータ取得
    let start = {
      year: +this.year,
      month: 7,
      day: new Date(this.year, 6, 1).getDate()
    }
    let end = {
      year: +this.year + 1,
      month: 6,
      day: new Date(this.year + 1, 6, 0).getDate()        //5月末日
    }

    this.analysisService.getSalesSummary(start, end).subscribe(result => {
      this.now_summary = this.analysis(result);
    })
    this.analysisService.getSalesSummary(this.start_span, this.end_span).subscribe(result => {
      this.summary_list = this.analysis(result);
    })
  }

  //売上リストの初期化処理
  listInit() {
    this.months.forEach(month => {
      this.summary_list[month] = {
        month: month,
        summary: [],
        plan_pay: 0,
        pay: 0
      }
    });
  }

  //売上集計
  analysis(summary) {
    this.listInit();
    let list = [];

    summary.construction.forEach(pay => {
      let temp = new Summary;
      temp.name = pay.customer_name;
      temp.category = '着工金';
      temp.plan_date = pay.construction_payment_plandate;
      temp.pay_date = pay.construction_payment_date;
      temp.plan = pay.construction_payment_plan;
      temp.payment = pay.construction_payment;
      list.push(temp);
    });

    summary.midway.forEach(pay => {
      let temp = new Summary;
      temp.name = pay.customer_name;
      temp.category = '中間金';
      temp.plan_date = pay.midway_payment_plandate;
      temp.pay_date = pay.midway_payment_date;
      temp.plan = pay.midway_payment_plan;
      temp.payment = pay.midway_payment;
      list.push(temp);
    });

    summary.final.forEach(pay => {
      let temp = new Summary;
      temp.name = pay.customer_name;
      temp.category = '最終金';
      temp.plan_date = pay.final_payment_plandate;
      temp.pay_date = pay.final_payment_date;
      temp.plan = pay.final_payment_plan;
      temp.payment = pay.final_payment;
      list.push(temp);
    });

    //日付順にソート
    list.sort(function (a, b) {
      return (a.plan_date > b.plan_date ? 1 : -1);
    });

    //月別に
    let temp_list = JSON.parse(JSON.stringify(this.summary_list));
    list.forEach(pay => {
      let month = new Date(pay.plan_date).getMonth() + 1;
      temp_list[month].summary.push(pay);
      temp_list[month].plan_pay += Number(pay.plan);

      month = new Date(pay.pay_date).getMonth() + 1;
      temp_list[month].pay += Number(pay.payment);
    })

    return temp_list;
  }

  ListShow(year: number, month: number): boolean {
    if (month < 7) year++;
    let sel = new Date(year, month);
    let now = new Date(new Date().getFullYear(), new Date().getMonth() + 1);
    if (now < sel) {
      return true;
    }
    return false;
  }

  //Excel出力
  output() {
    var start_date = this.start_span.year + "-" + this.start_span.month + "-" + this.start_span.day;
    var end_date = this.end_span.year + "-" + this.end_span.month + "-" + this.end_span.day;
    if (this.span == "now") {
      let now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var day_s = new Date(now.getFullYear(), now.getMonth(), 1).getDate();
      var day_e = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
      start_date = year + "-" + month + "-" + day_s;
      end_date = year + "-" + month + "-" + day_e;
    }

    let res = this.outputService.summary(this.span, start_date, end_date, this.summary_list, this.now_summary)
    res.subscribe(res => {
      const url = this.srcurl + "output/summary/売上集計_" + start_date + "~" + end_date + ".xlsx";
      window.open(url);
    });
  }

}
